import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.collection.content}}\n  <ul class=\"select-kit-errors-collection\">\n    {{#each this.collection.content as |item|}}\n      <li class=\"select-kit-error\">{{item}}</li>\n    {{/each}}\n  </ul>\n{{/if}}", {
  moduleName: "select-kit/components/select-kit/errors-collection.hbs"
});